/* global document */
import debounce from 'lodash.debounce';
import { gsap } from 'gsap';

const createSwipeGallery = (id, slides) => {
  const { rootDocument } = store.getState(); // eslint-disable-line no-undef
  let currentSlide = 0;
  let isDragging = false;
  let xChangePercentage = 0;
  let startX = 0;
  let startY = 0;
  const slideCount = slides.length;
  const slider = rootDocument.getElementById(id).childNodes[0];
  const dummy = slider.childNodes[slider.childNodes.length - 1];
  const images = [].slice.call(slider.childNodes, 0, -1);
  const width = slider.getBoundingClientRect().width;
  const event = rootDocument.createEvent('Event');
  event.initEvent('slide-transition', true, true);
  const autoPlay = slider.getAttribute('data-autoplay') === 'true';
  const autoPlayDuration = parseInt(slider.getAttribute('data-delay'), 10);
  const nextId = '';
  const prevId = '';
  slider.style.pointerEvents = 'all';
  slider.parentNode.setAttribute('data-currentslide', currentSlide);

  const setDataAttributes = () => {
    slider.parentNode.setAttribute('data-previousslide', slider.parentNode.getAttribute('data-currentslide'));
    slider.parentNode.setAttribute('data-currentslide', currentSlide);
  };

  const nextSlide = () => {
    if ((currentSlide + 1) < slideCount) {
      return currentSlide + 1;
    }
    return 0;
  };

  const prevSlide = () => {
    if (currentSlide > 0) {
      return currentSlide - 1;
    }
    return slideCount - 1;
  };

  const next = () => {
    gsap.to(images[currentSlide], 0.5, { left: '-100%' });
    currentSlide = nextSlide();
    gsap.fromTo(images[currentSlide], 0.5, { left: '100%' }, { left: '0%' });
    setDataAttributes();
    slider.dispatchEvent(event);

    if (autoPlay) {
      gsap.delayedCall(autoPlayDuration, next);
    }
  };

  const prev = () => {
    gsap.to(images[currentSlide], 0.5, { left: '100%' });
    currentSlide = prevSlide();
    gsap.fromTo(images[currentSlide], 0.5, { left: '-100%' }, { left: '0%' });
    setDataAttributes();
    slider.dispatchEvent(event);
  };

  const swipeTo = (percentage, time = 0) => {
    gsap.to(images[currentSlide], time, { left: `${percentage}%` });
    gsap.to(images[nextSlide()], time, { left: `${percentage + 100}%` });
    gsap.to(images[prevSlide()], time, { left: `${percentage - 100}%` });
  };

  const snap = () => {
    if (!isDragging) return;
    isDragging = false;
    if (xChangePercentage === 0) return;
    if (xChangePercentage > 10) {
      swipeTo(100, 0.25);
      currentSlide = prevSlide();
      xChangePercentage = 0;
      setDataAttributes();
      slider.dispatchEvent(event);
      return;
    }
    if (xChangePercentage < -10) {
      swipeTo(-100, 0.25);
      currentSlide = nextSlide();
      xChangePercentage = 0;
      setDataAttributes();
      slider.dispatchEvent(event);
      return;
    }
    swipeTo(0, 0.25);
    xChangePercentage = 0;
  };

  gsap.to(images[currentSlide], 0, { left: '0%' });
  if (autoPlay) {
    gsap.delayedCall(autoPlayDuration, next);
  }
  const nextDebounced = debounce(next, 1000);
  const prevDebounced = debounce(prev, 1000);

  const rootWindow = rootDocument.parentWindow || rootDocument.defaultView;

  rootWindow.HTMLDivElement.prototype.next = next;
  rootWindow.HTMLDivElement.prototype.prev = prev;

  const updateFrame = (e) => {
    if (!isDragging) return;
    const xValue = e.x || e.targetTouches[0].pageX;
    const yValue = e.y || e.targetTouches[0].pageY;
    const xChange = xValue - startX;
    const yChange = yValue - startY;
    if (xChange > yChange) e.preventDefault();
    xChangePercentage = (xChange / width) * 100;
    if (xChangePercentage < -100) xChangePercentage = -100;
    if (xChangePercentage > 100) xChangePercentage = 100;
    swipeTo(xChangePercentage);
  };
  if (nextId) {
    rootDocument.getElementById(nextId).onclick = () => {
      nextDebounced();
    };
  }
  if (prevId) {
    rootDocument.getElementById(prevId).onclick = () => {
      prevDebounced();
    };
  }

  const startDrag = (e) => {
    isDragging = true;
    startX = e.x || e.targetTouches[0].pageX;
    startY = e.y || e.targetTouches[0].pageY;
  };

  try {
    slider.addEventListener('mousedown', startDrag);
    slider.addEventListener('mousemove', updateFrame);
    slider.addEventListener('mouseup', snap);
    rootDocument.addEventListener('mouseup', snap);
    slider.addEventListener('touchstart', startDrag);
    slider.addEventListener('touchmove', updateFrame);
    slider.addEventListener('touchend', snap);
    rootDocument.addEventListener('touchend', snap);
  } catch (e) {
    console.log(e);
  }
};

export default createSwipeGallery;



// WEBPACK FOOTER //
// ./app/javascript/renderer/utils/swipeGalleryScript.js